export default class AvatarCache {

  constructor() {
    this.urls = {};
  }

  getUrl(username){
    return this.urls[username];
  }
  setUrl(username, url){
    this.urls[username] = url;
  }
}



// WEBPACK FOOTER //
// ./client/app/components/avatar/avatarCache.service.js